import { specKey } from "../spec";
import type { ViewSpec } from "../spec";
import unitDetail from "./unit.detail.teacher.json";
import lessonDetail from "./lesson.detail.teacher.json";

// THE AUTHORED SPECS: the canonical teacher screens, decided on purpose.
//
// They win over the schema-derived default because somebody chose this order and these labels for
// a reason the schema cannot know — that a teacher opening a lesson is asking what it teaches, so
// the skill comes before the handout. The default producer cannot know that and should not guess.
//
// THEY ARE JSON FILES, imported rather than fetched. Vite inlines them at build time, so a screen
// costs no round trip to find out what it looks like, and a spec that does not parse breaks the
// build rather than a teacher's page. When the generated producer arrives it will be served from
// the API — that is a different producer, not a different home for these.
//
// EACH SPEC KEYS ITSELF. The key is built from the spec's own entityType, audience, intent and
// versions, so a file cannot be filed under a context it is not for. Writing the keys out by hand
// here is how you get a lesson spec answering for units the first time somebody copies a line.

const FILES = [unitDetail, lessonDetail] as unknown as ViewSpec[];

const AUTHORED: Record<string, ViewSpec> = Object.fromEntries(
  FILES.map((spec) => [
    specKey({
      entityType: spec.entityType,
      audience: spec.audience,
      intent: spec.intent,
      schemaVersion: spec.schemaVersion,
    }, spec.registryVersion),
    spec,
  ]),
);

export default AUTHORED;
